exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yolcum-nerede-page[data-v-3d32316d]{min-height:100vh;background:#f1f3f5}.page-card[data-v-3d32316d]{min-height:100vh}.page-toolbar[data-v-3d32316d]{-webkit-box-shadow:0 2px 8px rgba(0,0,0,.18);box-shadow:0 2px 8px rgba(0,0,0,.18)}.page-container[data-v-3d32316d]{padding-top:22px}.filter-card[data-v-3d32316d]{background:#fff;border-radius:4px}.report-table-host[data-v-3d32316d]{width:100%}.cell-click-area[data-v-3d32316d]{display:block;width:100%;min-height:24px}.pnr-link[data-v-3d32316d]{color:#1976d2;text-decoration:underline;cursor:pointer}@media (max-width:960px){.page-container[data-v-3d32316d]{padding-top:16px}}", ""]);

// exports
